package learning.components


import LearningRoute
import antd.alert.alert
import antd.avatar.avatar
import antd.button.button
import antd.icon.messageOutlined
import antd.layout.space
import antd.list.ListComponent
import antd.list.list
import antd.list.listItem
import antd.list.listItemMeta
import antd.message.message
import antd.pagination.PaginationConfig
import com.jingfangpai.common.orm.mapping.enums.ContentType
import com.jingfangpai.common.orm.mapping.enums.UserPermissionContent
import com.jingfangpai.content.model.ContentQuery
import com.jingfangpai.content.model.ContentVo
import react.*
import kotlinext.js.js
import kotlinext.js.jsObject
import kotlinx.html.js.onClickFunction
import kotlinx.html.unsafe
import react.dom.*
import react.router.dom.useHistory
import learning.containers.GuideLinesPageContext
import user.service.CurrentUserPermission

external interface GuideLinesProps : RProps {

}

val GuideLines = functionalComponent<GuideLinesProps> { props ->

    val ctx = useContext(GuideLinesPageContext)
    val history = useHistory()
    val (query,setQuery) = useState(ContentQuery().apply {
        type = ContentType.Guideline
        includeComments = false
    })
    val (guidelines,setGuidelines) = useState(arrayOf<ContentVo>())

    useEffectOnce {
        ctx.query(query,{ resp ->
            if(resp.ok()){
                setGuidelines(resp.data?:arrayOf())
            }else{
                message.error("获取指引出错：${resp.message}")
            }
        },{
            message.error("获取指引出错：${it.message}")
        })
    }

    div("guidelines") {
        list<ContentVo, ListComponent<ContentVo>> {
            attrs {
                itemLayout = "vertical"
                size = "large"
                pagination = jsObject<PaginationConfig> {
                    onChange = { page: Number, pageSize: Number? -> }
                    pageSize = 30
                }
                dataSource = guidelines
                renderItem = { item: ContentVo, index: Number ->
                    listItem {
                        attrs {
                            key = "${item.id}"
                            //actions = arrayOf(
                                /*buildElement {
                                    space {
                                        starOutlined {}
                                        +"156"
                                    }
                                },
                                buildElement {
                                    space {
                                        likeOutlined {}
                                        +"156"
                                    }
                                },*/
                                /*buildElement {
                                    space {
                                        messageOutlined {}
                                        +"${item.comments.size}"
                                    }
                                },*/
                                /*buildElement {
                                    space {
                                        button {
                                            attrs{
                                                onClick = {
                                                    if (CurrentUserPermission.hasPerm(UserPermissionCommunity.评论话题)){
                                                        history.push(CommunityRoute.TopicCommentEdit.link.url.replace(":topicId",item.id?:"").replace(":commentId","new"))
                                                    }else{
                                                        message.error("对不起，您暂不能参与话题")
                                                    }
                                                }
                                            }
                                            +"我有话说"
                                        }
                                    }
                                }*/
                            //)
                            /*extra = buildElement {
                                img {
                                    this.attrs {
                                        width = "272"
                                        alt = "logo"
                                        src = "https://gw.alipayobjects.com/zos/rmsportal/mqaQswcyDLcXyDKnZfES.png"
                                    }
                                }
                            }*/
                        }
                        listItemMeta {
                            attrs {
                                avatar = buildElement {
                                    avatar {
                                        attrs.src =
                                            "https://gw.alipayobjects.com/zos/rmsportal/mqaQswcyDLcXyDKnZfES.png"
                                    }
                                }
                                title = buildElement {
                                    div{
                                        if(CurrentUserPermission.hasPerm(UserPermissionContent.发布学习指引)){
                                            a {
                                                attrs{
                                                    jsStyle = js{
                                                        float = "right"
                                                    }
                                                    onClickFunction = {
                                                        history.push(LearningRoute.GuidelineEdit.link.url.replace(":id",item.id!!))
                                                    }
                                                }
                                                +"编辑"
                                            }
                                        }
                                        +"${item.title ?: ""}"
                                    }
                                }
                                //description = "${item.description}"
                            }
                        }
                        alert {
                            attrs{
                                style = js{
                                    margin = "16px 0"
                                }
                                message = buildElement {
                                    div{
                                        attrs.unsafe {
                                            +"${item.content?:""}"
                                        }
                                    }
                                }
                            }
                        }
                        /*list<Comment,ListComponent<Comment>> {
                            attrs{
                                className = "comment-list"
                                header = *//*if(item.comments.size>0) "${item.comments.size}条讨论" else "暂无讨论"*//*"回答："
                                itemLayout = "horizontal"
                                dataSource = item.comments.toTypedArray()
                                renderItem = {commentItem,index ->
                                    buildElement {
                                        li {
                                            comment {
                                                attrs{
                                                    actions = arrayOf()
                                                    author = commentItem.createdBy
                                                    avatar = "https://joeschmoe.io/api/v1/random"
                                                    content = buildElement {
                                                        div{
                                                            div{
                                                                attrs.unsafe {
                                                                    +(commentItem.comment?:"")
                                                                }
                                                            }
                                                            div{
                                                                button{
                                                                    attrs{
                                                                        type = "link"
                                                                        onClick = {
                                                                            history.push(CommunityRoute.TopicCommentEdit.link.url.replace(":topicId",item.id?:"").replace(":commentId",commentItem.id?:""))
                                                                        }
                                                                    }
                                                                    +"修改评论"
                                                                }
                                                            }
                                                        }
                                                    }
                                                    datetime = commentItem.timestamp
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }*/
                    }
                }
                header = buildElement {
                    div {
                        span{
                            attrs {
                                jsStyle = js {
                                    float = "right"
                                }
                            }
                            if(CurrentUserPermission.hasPerm(UserPermissionContent.发布学习指引)) {
                                button {
                                    attrs {
                                        type = "primary"
                                        onClick = {
                                            history.push(LearningRoute.GuidelineEdit.link.url.replace(":id", "new"))
                                        }
                                    }
                                    +"添加指引"
                                }
                            }
                        }
                        h2("title") {
                            +"中医学习指引"
                        }
                    }
                }
                footer = buildElement {
                    div{}
                }
            }
        }
    }
}
